import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue'
import {
  type MetricAssignmentType,
  type MetricValueType,
  MetricValueKind,
  useUpsertMetricValuesMutation,
} from '~/types/types'
import { replaceCommaAndParseFloatOrNull } from '~/assets/helper/functions'
import { useGhgGrowthFactorAssignments } from './useGhgGrowthFactorAssignments'


export default /*#__PURE__*/_defineComponent({
  __name: 'GrowthFactorAssignments',
  props: {
    impactData: { default: undefined },
    impactGoalData: { default: undefined },
    impactSolutionData: { default: undefined },
    actualOrTarget: null,
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { impactData: Record<string, any>, impactGoalData: Record<string, any>, impactSolutionData: Record<string, any>, actualOrTarget: 'actual' | 'target', disabled: boolean };



const { impactData, impactGoalData, impactSolutionData } = toRefs(props)
const { metricAssignments, ghgStartingYear } = useGhgGrowthFactorAssignments(
  impactData,
  impactGoalData,
  impactSolutionData,
)

const { mutate: upsertMetricValuesMutation } = useUpsertMetricValuesMutation()

const periods = computed(() =>
  Array.from({ length: 5 }, (_, i) => ghgStartingYear.value + i),
)

const getMetricValueForPeriod = (
  item: MetricAssignmentType,
  period: number,
): MetricValueType => {
  const metric = item.metric
  const periodStr = String(period)
  const existing = item.metricValues?.find((val) => val.period === periodStr)
  if (existing) return existing as MetricValueType

  return {
    id: `${item.id}_${periodStr}`,
    metricAssignmentId: item.id,
    period: periodStr,
    actual: null,
    target: null,
    text: null,
    options: null,
    skipped: false,
    editable: metric ? !metric.isComputed : false,
    isConditionMet: true,
    type: metric?.valueType ?? MetricValueKind.Float,
  } as MetricValueType
}

const updateMetricValue = (value: any) => {
  if (props.disabled) return
  const input: {
    metricAssignmentId: number
    period: string
    actual?: number | null
    target?: number | null
  } = {
    metricAssignmentId: Number.parseInt(String(value.metricAssignmentId), 10),
    period: value.period,
  }

  if (props.actualOrTarget === 'actual') {
    input.actual = replaceCommaAndParseFloatOrNull(value.actual)
  }

  if (props.actualOrTarget === 'target') {
    input.target = replaceCommaAndParseFloatOrNull(value.target)
  }

  upsertMetricValuesMutation({
    inputs: [input],
  })
}

return { __sfc: true,props, impactData, impactGoalData, impactSolutionData, metricAssignments, ghgStartingYear, upsertMetricValuesMutation, periods, getMetricValueForPeriod, updateMetricValue }
}

})